import { isEqual } from "lodash";
import { memo } from "react";
import "./Dots.scss";
const Dots = memo(() => {
  return <span className="dots"></span>;
}, isEqual);
export default Dots;
